import { Component, OnInit, Input } from '@angular/core';

import { RouterDirective } from '../../_common';

@Component({
  selector:    'menu',
  template: require('./menu.component.html'),
  styles: [ require('./menu.component.css') ],
  providers: [ RouterDirective ],
})

export class MenuComponent implements OnInit {

  @Input('isMenu') isMenu: number;

  public constructor( ){}

  public ngOnInit() {
    console.log('Web Tar Get Menu');
  }

}



// WEBPACK FOOTER //
// node_modules/angular2-template-loader!./src/app/web-targets/menu/menu.component.ts